import { Component, Input, OnInit } from '@angular/core';
import { Route } from '../../models/flightSearch';
import { CommonService } from '../../common/services/common.service';
import { CalculateLuggageWeight } from '../../services/baggageHanlderService';

@Component({
    selector: 'app-flight-segment',
    templateUrl: 'flight-segment.component.html',
    styleUrls:['./flight-segment.component.css']
})

export class FlightSegmentComponent implements OnInit {
    @Input() passengerCounts:any={};
    @Input() selectedRouteOption:any={};
    @Input() tripType:string='';
    @Input() selectedReturnRouteOption:any={};
    showDeptStopover = false;
    showDirect=false;
    showReturnStopover = false;
    showReturnDirect=false;
    inviteMap: any = {'Sunday': 'zondag', 'Monday': 'maandag.', 'Tuesday': 'dinsdag','Wednesday':'woensdag','Thursday':'donderdag','Friday':'vrijdag','Saturday':'zaterdag'};
    constructor(public _commonService:CommonService) { }

    ngOnInit() { }

    getFlightNumbers(segments:any){
        var flightNo:string='';
        for(var i=0;i<segments.length;i++){
          if(i ==0){
            flightNo = segments[0].Number;
          }else{
            flightNo += " | "+segments[i].Number;
          }
        }
    
        return flightNo;
    
      }

      generateBaggageDetails(route:Route){
        return CalculateLuggageWeight(route);
      }

  containParticularText(textVal:any)
  {
    
    if(textVal != null)
    {
      if(textVal.toString().includes('kg')){
        return '';
      }
      else
      {
        return 'kg';
      }
    }
    else
    {
      return '';
    }
  }
      
}